import logo from './logo.svg';
import './App.css';
import React, { useMemo, useState, useEffect } from 'react';

import { ShareContext } from './context/ShareContext';
import Login from './pages/login';
import { BrowserRouter as Router, Route, Routes,useLocation } from 'react-router-dom';
import Profile from './pages/profile/profile';
import GeneralLayout from './components/core/generallayout';
import MainLayout from './components/core/mainlayout';
import ManageRole from './pages/profile/managerole';
import Register from './pages/register';
import ForgetPassword from './pages/forgetpassword';
import Filing_Case from './pages/filing_case';
import Filing_Motion from './pages/filing_motion';
import Dashboard from './pages/dashboard';
import * as Constants from './constants';
import ManageUsers from './pages/profile/manageusers';
import MyCases from './pages/my_cases';
import PaymentConfirm from './pages/callbacks/paymentconfirm';
import MyDraftCases from './pages/my_draft_cases';
import DocumentUpload from './pages/document_upload';
import Fiats from './pages/fiats';
import CaseDetailsAll from './pages/caseDetailsAll';
import PsaCases from './pages/psa_cases';
import PagePayment from './pages/payment';
import ResetPassword from './pages/passwordreset';
import UncompletedUploads from './pages/uncompleted_uploads';
import FilingDocument from './pages/filing_document';
import FilingClaim from './pages/filing_claim';
import ESwearing from './pages/ewearing';
import CaseAssociationRequest from './pages/case_association_request';
import PrepareDocument from './pages/preparedocument';
import CfoSwearing from './pages/cfo_swearing';
import UpdateProfile from './pages/profile/updateprofile';
import CfoPrepareDocument from './pages/cfo_preparedocument';
import Screeners from './pages/screeners';
import ACRScreen from './pages/acrs';
import ServiceSherrif from './pages/sheriff/service_sherrif';
import CaseAssignmentJudge from './pages/judge/assignment_judge';
import JudgeCases from './pages/judge/judge_cases';
import CaseScheduler from './pages/judge/case_scheduler';
import Hearing from './pages/judge/hearing';
import DeputySheriff from './pages/sheriff/deputy_sheriff';
import GazetteSetup from './pages/setups/gazette_setup';
import CreateTemplate from './pages/template/create_template';
import Placeholder from './pages/template/placeholder';
import ViewTemplate from './pages/template/view_template';
import Templates from './pages/template/templates';
import EmailTemplate from './pages/setups/email_template';
import AffidavitDocuments from './pages/affidavit/affidavit_documents';
import ViewAffidavits from './pages/affidavit/view_affidavit';
import ConfirmAffidavitPayment from './pages/affidavit/affidavit_confirmpayment';
import PaymentGateway from './pages/payment/gateway';
import ConfirmInternalOnly from './pages/callbacks/confirm_internalonly';
import AffidavitUpload from './pages/affidavit/affidavit_upload';
import PrepareAffidavit from './pages/affidavit/prepare_affidavit';
import DocReceipt from './pages/receipts/doc_receipt';
import InternalReceipt from './pages/receipts/int_receipt';
import CaseSettings from './pages/setups/case_settings';
import CourtSettings from './pages/setups/court_settings';
import JudgeSettings from './pages/setups/judge_settings';
import JudgementSettings from './pages/setups/judgement_settings';
import LocationSettings from './pages/setups/location_settings';
import VacationSetup from './pages/setups/vacation_setup';
import VacationCases from './pages/vacation/vacation_cases';
import Report_CaseWaitingAssignmnet from './pages/report/case_waiting_assignment';
import PreviewTemplate from './pages/template/preview_template';
import Report_Njc_3c from './pages/report/njc_3c';
import LandingPage from './pages/cms/landing';
import CfoSwearingSheriff from './pages/sheriff/cfo_swearing_sheriff';
import PreviewLiveTemplate from './pages/template/preview_live_template';
import AdrAdminCases from './pages/adr/ade_admin_cases';
import GeneralCases from './pages/general/general_cases';
import JudgeAdrCases from './pages/judge/judge_cases_adr';
import Firms from './pages/firm/firms';
import AttorneyRequests from './pages/firm/attoneyrequest';
import CaseAssociations from './pages/case_associations';
import Njc3Report from './pages/report/njc3report';
import AboutUs from './pages/cms/aboutus';
import Mediation from './pages/adr/mediation';
import CourtRegisterCases from './pages/judge/court_register';
import LandingNew from './pages/cms/landingnew';
 
import  AboutPage  from './landing/pages/AboutPage';
import  ProboPub  from './landing/pages/ProbatePub';
import  CauseList  from './landing/pages/CauseLists';
import  EFilingPage  from './landing/pages/EFilingPage';
import  ContactPage  from './landing/pages/ContactPage';
import  NewsPage  from './landing/pages/NewsPage';
import  SearchResultsPage  from './landing/pages/SearchResultsPage';
import  DailyListPage  from './landing/pages/DailyListPage';
import  AdvanceCauseListPage  from './landing/pages/AdvanceCauseListPage';
import  SupplementaryListPage  from './landing/pages/SupplementaryListPage';
import  OnlineSearch  from './landing/pages/OnlineSearch';
import  OnlineSearchResultsPage  from './landing/pages/OnlineSearchResultsPage';
import  VerificationHighCourt  from './landing/pages/VerificationHighCourt';
import Gallery from './landing/pages/Gallery';
import  GalleryEvent  from './landing/pages/GalleryEvent';
import  NewsLanding from './landing/pages/NewsLanding';
import  NewsSingle from './landing/pages/NewsSingle';
import ServiceSherrifSubstitutted from './pages/sheriff/service_sherrif_substituted';
import CfoSwearingSheriffSubstituted from './pages/sheriff/cfo_swearing_sheriff_substituted';
import CMSSetup from './pages/cms/cms_setup';
import PrincipalOfficers from './landing/pages/PrincipalOfficers';
import HeadsofUnit from './landing/pages/HeadsofUnit';
import RetiredChiefJudges from './landing/pages/RetiredChiefJudges';
import RetiredElevatedDeceasedJudges from './landing/pages/RetiredElevatedDeceasedJudges';
import JudgesMagistrates from './landing/pages/JudgesMagistrates';
import PostJudgementCases from './pages/post_judgement/post_judgement_cases';
import AcrPostJudgementCases from './pages/post_judgement/acr_post_judgement';
import HOPWritCases from './pages/post_judgement/head_of_service_cases';
import PostDeputySheriff from './pages/post_judgement/post_deputy_sheriff';
import HeadOfAppealWritCases from './pages/post_judgement/post_head_of_appeal';
import JudgeWarrantCases from './pages/post_judgement/judge_warrant';
import ExecutionSherrif from './pages/post_judgement/execution_sheriff';
import StoreKeeper from "./pages/post_judgement/store_keeper";
import JudgeApprovalSales from "./pages/post_judgement/judge_approve_items";
import AuctionCompletedCases from "./pages/post_judgement/aution_completed_cases";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
};

function App() {
  const [whichUpload, setWhichUpload] = useState('');
  const [profile, setProfile] = useState(null);
  const [isHeader, setIsHeader] = useState(true);
  const [token, setToken] = useState(null);
  const [activePage, setActivePage] =useState({});
  const [checkingToken, setCheckingToken] = useState(true);
  const [sidelinks, setSidelinks] =useState([]);
  const [frequentData, setFrequentData] =useState({}); //this is holding all the type related
  const [isExpired, setIsExpired] = useState(false);
  const [alert, setAlert] = useState({open:false})
  const filingType=[
    {label:'All',value:0},{label:'Litigation',value:1},{label:'ADR',value:2}];

  useEffect(() => {
  const checkToken = async () => {
    const storedToken = localStorage.getItem("token");
    const pro=localStorage.getItem("profile");
    const freqdata=localStorage.getItem("freqdata");
    if (storedToken) {
      try {
        const response = await fetch(`${Constants.apiUrl}/profile/validate-token`, {
          body:"str",
          method: "POST",
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        });

        if (response.ok) {
          setToken(storedToken); // Token valid
          setProfile(JSON.parse(pro));
          setFrequentData(JSON.parse(freqdata));

        } else {
          localStorage.removeItem("token");
          localStorage.removeItem("profile");
          setToken(null);

        }
        setCheckingToken(false);
      } catch (error) {
        console.error("Token check failed:", error);
        setToken(null);
      }
    } else {
      setToken(null);
       setCheckingToken(false);
    }
  };

  checkToken();
}, []);

  useEffect(() => {
    
     if(token!=null){
      //load the menu
      onLoadMenu();
     }
  }, [token]);

   const onLoadMenu= async()=>{
      //for account registration
      try {
       // setLoading(true);
          const resp = await fetch(`${Constants.apiUrl}/profile/side-menu`, { 
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          });
          
          const data = await resp.json();
          if(data.code==0){
           
              if(data.screens.length>0){
                      const groupedMenu = data.screens.reduce((acc, item) => {
                    if (item.isParent) {
                      const children = data.screens.filter(child => child.parentId === item.id);
                      if (children.length > 0) {
                        acc.push({ ...item, inner: children });
                      } else {
                        acc.push(item);
                      }
                    } else if (!item.parentId) {
                      acc.push(item);
                    }
                    return acc;
                  }, []);
                  console.log(groupedMenu)
                  setSidelinks(groupedMenu);
                }
              }
            
         
          
         
        } catch (error) {
        //  setLoading(false);
          console.error(error);
          
        }
  }


  
  
  


  // STEP 2️⃣: Memoize the context value to prevent unnecessary re-renders
  const shareContextValue = useMemo(() => ({
    whichUpload,
    setWhichUpload,
    profile,
    setProfile,
    isHeader,
    setIsHeader,
    token,
    setToken,sidelinks, setSidelinks, activePage, setActivePage, checkingToken, setCheckingToken,filingType,frequentData, setFrequentData,isExpired, setIsExpired,alert, setAlert
  }), [whichUpload, profile, isHeader, token,sidelinks, activePage,checkingToken,filingType,frequentData,isExpired,alert]);  // Only re-computes if any of these change.

  return (
    <div className="App">
      <ShareContext.Provider value={shareContextValue} >
        <Router>
          <ScrollToTop />
          <Routes>
           <Route path="/" element={<GeneralLayout />}>
         <Route path='/' element={<LandingNew/>} />   
        <Route path='/old' element={<LandingPage/>} /> 

        
            <Route path="/about" element={<AboutPage />} />
            <Route path="/ProbatePub" element={<ProboPub />} />
            <Route path="/e-filing" element={<EFilingPage />} />
            <Route path="/online-search" element={<OnlineSearch/>} />
            <Route path="/online-search/results" element={<OnlineSearchResultsPage />} />
            <Route path="/CauseLists" element={<CauseList />} />
            <Route path="/VerificationHighCourt" element={<VerificationHighCourt />} />
            <Route path="/search/*" element={<VerificationHighCourt />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/cause-list/search" element={<SearchResultsPage />} />
            <Route path="/cause-list/daily" element={<DailyListPage />} />
            <Route path="/cause-list/advance" element={<AdvanceCauseListPage />} />
            <Route path="/cause-list/supplementary" element={<SupplementaryListPage />} />
            <Route path="/preview_page.html" element={<LandingNew />} />
            <Route path="/gallery" element={<Gallery/>} />
            <Route path="/gallery/:id" element={<GalleryEvent />} />
            <Route path="/newslanding" element={<NewsLanding />} />
            <Route path="/news/:id" element={<NewsSingle />} />
            <Route path="/PrincipalOfficers" element={<PrincipalOfficers />} />
            <Route path="/HeadsofUnit" element={<HeadsofUnit/>} />
            <Route path="/RetiredChiefJudges" element={<RetiredChiefJudges/>} />
            <Route path="/RetiredElevatedDeceasedJudges" element={<RetiredElevatedDeceasedJudges/>} />
            <Route path="/JudgesMagistrates" element={<JudgesMagistrates />} />

            <Route path="*" element={<LandingNew />} />

        
        <Route path='/aboutus' element={<AboutUs/>} />
        <Route path='/login' element={<Login/>} />
        <Route path="/register" element = {<Register/>} />
        <Route path="/forgetpassword" element = {<ForgetPassword/>} />
        <Route path='/reset-password/:resetkey' element={<ResetPassword/>} />
        <Route path="/receipt/:refid" element = {<DocReceipt/>} />
        <Route path="/receipt-internal/:refid" element = {<InternalReceipt/>} />
        <Route path="/template-document/:id" element = {<PreviewTemplate/>} />
        <Route path="/template-live-document/:id" element = {<PreviewLiveTemplate/>} />
        </Route> 

          <Route element={<MainLayout />}>
            <Route path='/profile' element={<UpdateProfile/>} />
            <Route path='/dashboard' element={<Dashboard/>} />
            <Route path='/managerole' element={<ManageRole/>} />
            <Route path='/case-filing/:caseid?' element={<Filing_Case/>} />
            <Route path='/motion-filing' element={<Filing_Motion/>} />
            <Route path='/manage-users' element={<ManageUsers/>} />
            <Route path='/my-cases' element={<MyCases/>} />
            <Route path='/confirm-pay/:fid?' element={<PaymentConfirm/>} />
            <Route path='/confirm-internal/:fid?' element={<ConfirmInternalOnly/>} />
            <Route path='/my-draft' element={<MyDraftCases/>} />
            <Route path='/document-upload/:casefeeid' element={<DocumentUpload/>} />
            <Route path='/fiats' element={<Fiats/>} />
            <Route path='/case-details/:caseid' element={<CaseDetailsAll/>} />
            <Route path='/psa-cases' element={<PsaCases/>} />
            <Route path='/payment/:feeid' element={<PagePayment/>} />
             <Route path='/pending-upload' element={<UncompletedUploads/>} />
             <Route path='/filing-document/:caseid?' element={<FilingDocument/>} />
             <Route path='/filing-motion/:caseid?' element={<Filing_Motion/>} />
             <Route path='/filing-claim/:caseid?/:claimid?' element={<FilingClaim/>} />
              <Route path='/e-swearing' element={<ESwearing/>} />   
              <Route path='/cfo-e-swearing' element={<CfoSwearing/>} />   
              <Route path='/case-association-request' element={<CaseAssociationRequest/>} />  
              <Route path='/case-associations' element={<CaseAssociations/>} /> 
              <Route path='/prepare-document/:docid/:role' element={<PrepareDocument/>} />    
              {/* <Route path='/cfo-prepare-document/:casefeeid' element={<CfoPrepareDocument/>} />  */}
              <Route path='/screeners' element={<Screeners/>} /> 
              <Route path='/acrs' element={<ACRScreen/>} /> 
              <Route path='/service-sherrif' element={<ServiceSherrif/>} /> 
              <Route path='/service-sherrif-subtituted' element={<ServiceSherrifSubstitutted/>} /> 
              <Route path='/deputy-sheriff' element={<DeputySheriff/>} /> 
              <Route path='/cfo-e-swearing-sheriff' element={<CfoSwearingSheriff/>} /> 
              <Route path='/cfo-e-swearing-sheriff-substituted' element={<CfoSwearingSheriffSubstituted/>} /> 


              <Route path='/case-assigment' element={<CaseAssignmentJudge/>} /> 
              <Route path='/adr-manager-cases/:managertype?' element={<AdrAdminCases/>} /> 
              <Route path='/adr-judge-cases' element={<JudgeAdrCases/>} /> 
              <Route path='/adr-mediation/:caseid' element={<Mediation/>} /> 

              <Route path='/case-scheduling/:eventtype' element={<JudgeCases/>} /> 
              <Route path='/case-scheduler' element={<CaseScheduler/>} />  
              <Route path='/hearing/:scheduleid' element={<Hearing/>} />  
              <Route path='/gazette-setup' element={<GazetteSetup/>} /> 

              <Route path='/templates/:type/:id/edit' exact element={<CreateTemplate />} />
              <Route path='/templates/:type/create' exact element={<CreateTemplate />} />
              <Route path='/templates/:temptype' exact element={<Templates />} />
              <Route path='/templates/:id/view' exact element={<ViewTemplate />} />
              <Route path='/templates/placeholders' exact element={<Placeholder />} /> 
              
              <Route path='/affidavits' exact element={<AffidavitDocuments />} />
              <Route path='/cfo-affidavits' exact element={<AffidavitDocuments />} />

              <Route path='/affidavits/:id' exact element={<ViewAffidavits />} />
              <Route path='/affidavit-upload/:docid' element={<AffidavitUpload/>} />
              <Route path='/affidavit-prepare/:docid/:role' element={<PrepareAffidavit/>} />

              <Route path='/affidavit/confirmpayment/:refid' exact element={<ConfirmAffidavitPayment />} /> 
              <Route path='/email-template' exact element={<EmailTemplate />} />

              <Route path='/setup/gateway' exact element={<PaymentGateway />} />
              <Route path='/setup/case' exact element={<CaseSettings />} />
              <Route path='/setup/court' exact element={<CourtSettings />} />
              <Route path='/setup/judge' exact element={<JudgeSettings />} />
              <Route path='/setup/judgement' exact element={<JudgementSettings />} />
              <Route path='/setup/location' exact element={<LocationSettings />} /> 
              <Route path='/setup/vacation' exact element={<VacationSetup />} /> 
              <Route path='/vacation-cases' exact element={<VacationCases />} /> 
              <Route path='/reports/case-awaiting-assignment' exact element={<Report_CaseWaitingAssignmnet />} /> 
              <Route path='/reports/njc-mcpj-3c' exact element={<Report_Njc_3c />} /> 
              <Route path='/reports/print/njc3/:eventtype/:judgeid/:divisionid/:lastdate' exact element={<Njc3Report />} /> 
              <Route path='/reports/search-cases' exact element={<GeneralCases />} /> 
              <Route path='/firms' exact element={<Firms />} />
              <Route path='/AttorneyRequests' exact element={<AttorneyRequests />} />
              <Route path='/admin-firms' exact element={<Firms />} />
              <Route path='/court-registrar' exact element={<CourtRegisterCases />} />
              <Route path='/cms/setup' exact element={<CMSSetup />} />
             
              <Route path='/post-judgement-cases' exact element={<PostJudgementCases />} />
              <Route path='/acr-writ-of-fifa' exact element={<AcrPostJudgementCases />} />
              <Route path='/hop-writ-of-fifa' exact element={<HOPWritCases />} />
              <Route path='/post-deputy-sherrif' exact element={<PostDeputySheriff />} />
              <Route path='/post-head-of-appeal' exact element={<HeadOfAppealWritCases />} />
              <Route path='/judge-warrants' exact element={<JudgeWarrantCases />} />
              <Route path='/execution-sheriff-cases' exact element={<ExecutionSherrif />} />
               <Route
                path="/store-keeper-cases"
                exact
                element={<StoreKeeper />}
              /> 
                <Route
                path="/judge-warrant-sales-cases"
                exact
                element={<JudgeApprovalSales />}
              /> 
                <Route
                path="/auction-completed-cases"
                exact
                element={<AuctionCompletedCases />}
              />
        </Route>
           
          </Routes>
         
        </Router>
      </ShareContext.Provider>
    </div>
  );
}

export default App;
